export default class E2EMFController {
	/* @ngInject */
	constructor() {
		/** @type {Ktable.Options} */
		const options = {
			display: {
				status: true,
			},
			actions: {
				delete: true,
				export: true,
				extra: [],
				refresh: true,
				filters: true,
				insert: true,
				upload: true,
			},
		};

		const query = {
			select: [
				{
					inherits_extended: 0,
					kid: 'K_NODE;CIVILITY',
					linker_kid: '0',
					name: 'Civilité',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;CIVILITY', name: 'Civilité', flow: 'down', linker_kid: '0',
						},
					],
					type: 'K_NODE;STRING',
				},
				{
					inherits_extended: 0,
					kid: 'K_NODE;LASTNAME',
					linker_kid: '0',
					name: 'Nom de famille',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;LASTNAME', name: 'Nom de famille', flow: 'down', linker_kid: '0',
						},
					],
					type: 'K_NODE;STRING',
				},
				{
					inherits_extended: 0,
					kid: 'K_NODE;FIRSTNAME',
					linker_kid: '0',
					name: 'Prénom',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;FIRSTNAME', name: 'Prénom', flow: 'down', linker_kid: '0',
						},
					],
					type: 'K_NODE;STRING',
				},
				{
					inherits_extended: 0,
					kid: 'NONE',
					linker_kid: '0',
					node: 'REPRE',
					nama: 'Workflow',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;PROFESSION', name: 'Profession', flow: 'down', linker_kid: '0',
						},
					],
					type: 'workflow',
				},
				{
					inherits_extended: 0,
					kid: 'K_NODE;PROFESSION',
					linker_kid: '0',
					name: 'Profession',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;PROFESSION', name: 'Profession', flow: 'down', linker_kid: '0',
						},
					],
					type: 'K_NODE;STRING',
				},
				{
					inherits_extended: 0,
					kid: 'K_NODE;DATE',
					linker_kid: 'K_NODE;BIRTH',
					name: 'Date',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;DATE',
							name: 'Date',
							flow: 'down',
							linker_kid: 'K_NODE;BIRTH',
							linker_info: { kid: 'K_NODE;BIRTH', name: 'Naissance' },
						},
					],
					type: 'K_NODE;STRING',
					linker_info: { kid: 'K_NODE;BIRTH', name: 'Naissance' },
				},
				{
					inherits_extended: 0,
					kid: 'K_NODE;EMAIL',
					linker_kid: '0',
					name: 'Email',
					node: 'REPRE',
					op: 'detail',
					path: [
						{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', flow: null },
						{
							kid: 'K_NODE;EMAIL', name: 'Email', flow: 'down', linker_kid: '0',
						},
					],
					type: 'K_NODE;STRING',
				},
			],
			from: [
				{
					node: 'K_NODE;PERSON_SYS',
					name: 'Personne',
					type: 'K_NODE;STRING',
					inherits_extended: 0,
					path: [{ kid: 'K_NODE;PERSON_SYS', name: 'Personne', linker_kid: '0' }],
				},
			],
			where: null,
		};

		// classic
		this.ktable1 = {
			options,
			query,
		};

		this.ktable2 = {
			options,
			query,
		};

		this.ktable3 = {
			options,
			query,
		};

		this.ktable4 = {
			options,
			query: {
				select: [
					{
						inherits_extended: -1,
						kid: 'K_NODE;YEAR',
						name: 'Année',
						node: 'REPRE',
						op: 'detail',
						type: 'K_NODE;INTEGER',
						width: 180,
					},
				],
				from: [
					{
						inherits_extended: -1,
						name: 'Année',
						node: 'K_NODE;YEAR',
						type: 'K_NODE;INTEGER',
					},
				],
				where: null,
			},
		};

		this.$onInit();
	}

	$doCheck() {}

	$onInit() {}
}
